<template>
  <DialogLayout
    title="詳細検索"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
    class="detail-search-dialog"
  >
    <template #form>
      <AirportMasterForm
        ref="airportForm"
        v-model="airportForm"
        label-width="10em"
        formMode="search"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
        :autocomplete-airport-name-set="autocompleteAirportNameSet"
      />
    </template>
    <template #footer>
      <SearchDialogFooter
        @clear="clickClear"
        @search="clickSearch"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import AirportMasterForm from '@/components/organisms/dialog/master/AirportMasterForm.vue'
import SearchDialogFooter from '@/components/organisms/dialog/SearchDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    AirportMasterForm,
    SearchDialogFooter
  },
  props: {
    model: Object,
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportNameSet: {
      type: Array,
      default: () => ([])
    },
    visible: Boolean
  },
  data () {
    return {
      airportForm: {
        airport_code: undefined,
        search_base_date: undefined,
        airport_name: undefined,
        remote_island_type: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  mounted () {
    // console.log('RegistrationSymbolMasterDetailSearchDialog.mounted')
  },
  methods: {
    clickClear () {
      this.$refs.airportForm.clearFields()
    },
    clickSearch () {
      this.$refs.airportForm.validate()
        .then((valid) => {
          sessionStorage.setItem('airportSearchCond', JSON.stringify(this.airportForm))
          this.dialogVisible = false
          this.$emit('search', this.airportForm)
        })
    },
    open () {
      const searchCond = JSON.parse(sessionStorage.getItem('airportSearchCond'))
      this.$nextTick(() => {
        this.$refs.airportForm.clearFields()
        if (searchCond) {
          Object.keys(this.airportForm).forEach((x) => {
            this.$set(this.airportForm, x, searchCond[x])
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
